import { defineMessages } from 'react-intl';

import { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';

import { OneTimeOnboardingDialog as OnboardingDialog } from '#src/components/market/OnboardingDialog/index.tsx';
import cover from '#src/components/market/assets/manager-sales.webp';
import { useCurrentMarketplaceUserContext } from '#src/contexts/currentMarketplaceUser/index.ts';

const messages = defineMessages({
  title: {
    defaultMessage: 'Manager Sales',
  },
  description: {
    defaultMessage:
      'Scout the next superstar and buy player cards directly from other Sorare Managers',
  },
});

export const ManagersSales = ({ enabled = true }: { enabled?: boolean }) => {
  const { boughtSingleSaleTokenOffers } = useCurrentMarketplaceUserContext();

  return (
    <OnboardingDialog
      title={messages.title}
      description={messages.description}
      img={cover}
      lifecycleKey={LIFECYCLE.sawManagersSalesOnboarding}
      show={!!enabled && boughtSingleSaleTokenOffers?.hasAny === false}
    />
  );
};
